import { render, staticRenderFns } from "./objection-reporting-error.vue?vue&type=template&id=34f0a5f2&lang=pug"
import script from "./objection-reporting-error.vue?vue&type=script&setup=true&lang=js"
export * from "./objection-reporting-error.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-feedback/dist/vue-feedback.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports